import type { PhotoActionId } from './types/photo-action-id'
import type { PhotoActionDefinition } from './types/photo-action-definition'

/** WMPCM-9864 / Figma PEZ — order matches RH context menu. */
export const PHOTO_ACTION_DEFINITIONS: PhotoActionDefinition[] = [
  { id: 'editPhoto', label: 'Edit photo', icon: 'pencil-line' },
  { id: 'photoEffects', label: 'Photo effects', icon: 'sparkles' },
  { id: 'cropPhoto', label: 'Crop photo', icon: 'crop' },
  { id: 'tagPhoto', label: 'Tag photo', icon: 'users' },
  { id: 'clippingPath', label: 'Clipping path', icon: 'pen-tool' },
  {
    id: 'removeBackground',
    label: 'Remove background',
    icon: 'eraser',
    toolbarLabel: 'Remove background',
  },
  { id: 'caption', label: 'Caption', icon: 'captions' },
  { id: 'removePhoto', label: 'Remove photo', icon: 'trash' },
]

/** Not yet wired — stay visually enabled when portrait rules allow. */
export const PHOTO_PLACEHOLDER_ACTION_IDS: ReadonlySet<PhotoActionId> = new Set([
  'editPhoto',
  'tagPhoto',
])

/**
 * WMPCM-12938 (supersedes WMPCM-11032's "disabled, not hidden") — the only Photo Actions that apply
 * to a placed ClikArt. A ClikArt has no candid `imageId`, so effects, tagging, background removal
 * and captions have nothing to act on; the toolbar and the left panel leave them out entirely
 * (`CLIKART_PHOTO_ACTION_DEFINITIONS`). The context menu still lists every photo action, so
 * `usePhotoPanelContext` keeps the rest disabled there.
 */
export const CLIKART_ENABLED_PHOTO_ACTION_IDS: ReadonlySet<PhotoActionId> = new Set([
  'editPhoto',
  'cropPhoto',
  'clippingPath',
  'removePhoto',
])

/** ClikArt wording for the actions it keeps; the rest of the definition (icon, order) is shared. */
const CLIKART_PHOTO_ACTION_LABELS: Partial<Record<PhotoActionId, string>> = {
  editPhoto: 'Edit ClikArt',
  cropPhoto: 'Crop ClikArt',
  removePhoto: 'Remove ClikArt',
}

/** What the toolbar and the left panel show for a selected ClikArt: the four supported actions, in
 *  the photo order (Edit, Crop, Clipping path, Remove), named for a ClikArt. */
export const CLIKART_PHOTO_ACTION_DEFINITIONS: PhotoActionDefinition[] =
  PHOTO_ACTION_DEFINITIONS.filter(({ id }) => CLIKART_ENABLED_PHOTO_ACTION_IDS.has(id)).map(
    (action) => ({ ...action, label: CLIKART_PHOTO_ACTION_LABELS[action.id] ?? action.label })
  )
